import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "./useRequests";

export const usePickupAction = () => {
  const { get } = useRequest();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ orderId, pin }: { orderId: string; pin: string }) => {
      const response = await get(`v1/transfer/act/pickup/${orderId}`, {
        pin: pin.trim(),
      });
      return response;
    },
    onSuccess: (data, variables) => {
      // Invalidate and refetch order data
      queryClient.invalidateQueries({ queryKey: ["order", variables.orderId] });
      queryClient.invalidateQueries({
        queryKey: ["logisticsForOrder", variables.orderId],
      });
    },
  });
};

export const useDeliveryAction = () => {
  const { get } = useRequest();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ orderId, pin }: { orderId: string; pin: string }) => {
      const response = await get(`v1/transfer/act/deliver/${orderId}`, {
        pin: pin.trim(),
      });
      return response;
    },
    onSuccess: (data, variables) => {
      // Invalidate and refetch order data
      queryClient.invalidateQueries({ queryKey: ["order", variables.orderId] });
      queryClient.invalidateQueries({
        queryKey: ["logisticsForOrder", variables.orderId],
      });
    },
  });
};
